import { render } from "./DelModal.vue?vue&type=template&id=517d033b"
import script from "./DelModal.vue?vue&type=script&lang=js"
export * from "./DelModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__